import { request } from "@/config/request/interceptors";
import { day } from "@/const";
import { CustomerDetailRespDTO, CustomerShopRespDTO } from "@/service/customer";
import { Commit, Dispatch } from "vuex";

// 定义 State 接口
interface UserState {
  userInfo?: CustomerDetailRespDTO;
  token?: string;
  curShop?: number;
}

// 修改 Patch 接口,使用具体的 State 类型
interface ModuleContext {
  commit: Commit;
  state: UserState; // 使用 UserState 替代 any
  dispatch: Dispatch;
}

export default {
  namespaced: true,
  state(): UserState {
    // 使用函数返回,避免引用共享
    return {
      userInfo: {},
      token: window.localStorage.getItem("token") ?? "",
      curShop: undefined,
    };
  },
  getters: {},
  mutations: {
    SET_TOKEN: (state: UserState, token: string) => {
      state.token = token;
      window.localStorage.setItem("token", token);
    },
    SET_USER_INFO: (state: UserState, userInfo: CustomerDetailRespDTO) => {
      state.userInfo = userInfo;
    },
    SET_CUR_SHOP: (state: UserState, curShop: number | undefined) => {
      state.curShop = curShop;
    },
  },
  actions: {
    GET_USER_INFO: async ({ commit, state, dispatch }: ModuleContext) => {
      // state 的类型现在是 UserState,有类型提示
      if (!state.token) return;
      try {
        const res = await request.customer.getCustomerDetail.getCustomerDetail({
          token: state.token,
        });
        if (res.success) {
          commit("SET_USER_INFO", res.data);
          commit("SET_CUR_SHOP", res.data?.customerShopList?.[0].customerShopId);
        } else {
          dispatch("logout");
        }
      } catch (error) {
        dispatch("logout");
      }
    },
    changeShop: async (
      { commit, state }: ModuleContext,
      customerShopId: number,
    ) => {
      const res = await request.customer.changeShop.changeShop({
        shopId: customerShopId,
      });
      if (res.success) {
        commit("SET_CUR_SHOP", customerShopId);
      }
    },
    changeToCkb: async (
      { commit, state, dispatch }: ModuleContext,
      url: string,
    ) => {
      if (!state.token) {
        window.location.href = "/account/signin";
      }
      const env = process.env.VUE_APP_ENV as "dev" | "test" | "pre" | "prod";

      const transUrl = {
        dev: `http://localhost:10001/transfer`,
        test: `https://master-s.theckb.com/transfer`,
        pre: `https://pre-s.theckb.com/transfer`,
        prod: `https://s.theckb.com/transfer`,
      }[env];
      if (state.userInfo?.accountType == 2) {
        window.open(`${transUrl}?token=${state.token}&curShop=${state.curShop}&redirect=${url}`, '_blank');
        return
      }

      // 2C主账户
      if (
        state.userInfo?.systemSource == 1 &&
        state.userInfo?.accountType == 1
      ) {
        const res = await request.customer.changeLogin.changeLogin();
        commit("SET_USER_INFO", res.data);
        commit("SET_TOKEN", res.data?.token);
        commit("SET_CUR_SHOP", res.data?.customerShopList?.[0].customerShopId);
      }
      const res = await request.customer.customer.shopAddLiveDeviceShop({});
      if (res.data) {
        await request.customer.changeShop.changeShop({ shopId: res.data });
        commit("SET_CUR_SHOP", res.data);
        window.open(`${transUrl}?token=${state.token}&curShop=${res.data}&redirect=${url}`, '_blank');
      }
    },
    logout({ commit, state, dispatch }: ModuleContext) {
      commit("SET_TOKEN", "");
      commit("SET_USER_INFO", {});
      commit("SET_CUR_SHOP", undefined);
    },
  },
  local: {
    token: 3 * day,
    curShop: 9999 * day,
  },
};
